import apiRoutes from './api.routes';
import ModelService from './model.service';

const SlideService = new ModelService(apiRoutes.slides, '/content/slides', 'content');

SlideService.getImage = (filename, w = false, h = false, c = false) => SlideService.getFilePathByDir('/uploads/slides', filename, w, h, c);
SlideService.getVideo = filename => (filename ? SlideService.getFilePathByDir('/uploads/slides', filename) : '');

export default SlideService;



// WEBPACK FOOTER //
// ./src/services/slide.service.js